import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/auth/AuthContext";
import {
  Graph, MagnifyingGlass, User, Stack, Robot, TrendUp, Warning,
  SealCheck, Presentation, TreeStructure,
} from "@phosphor-icons/react";
import { CP } from "@/components/capability/ui";
import GraphExplorer from "@/components/capability/GraphExplorer";
import PeopleProfile from "@/components/capability/PeopleProfile";
import SkillDetail from "@/components/capability/SkillDetail";
import ExpertSearch from "@/components/capability/ExpertSearch";
import TeamAdvisor from "@/components/capability/TeamAdvisor";
import DemandDashboard from "@/components/capability/DemandDashboard";
import GapAnalysis from "@/components/capability/GapAnalysis";
import EvidencePanel from "@/components/capability/EvidencePanel";
import ExecutiveDashboard from "@/components/capability/ExecutiveDashboard";
import TaxonomyAdmin from "@/components/capability/TaxonomyAdmin";

const TABS = [
  { value: "explorer", label: "Graph Explorer", icon: Graph, component: GraphExplorer, testid: "cap-tab-explorer" },
  { value: "people", label: "People", icon: User, component: PeopleProfile, testid: "cap-tab-people" },
  { value: "skills", label: "Skills", icon: Stack, component: SkillDetail, testid: "cap-tab-skills" },
  { value: "experts", label: "Experts", icon: MagnifyingGlass, component: ExpertSearch, testid: "cap-tab-experts" },
  { value: "advisor", label: "Team AI", icon: Robot, component: TeamAdvisor, testid: "cap-tab-advisor" },
  { value: "demand", label: "Demand", icon: TrendUp, component: DemandDashboard, testid: "cap-tab-demand" },
  { value: "gaps", label: "Gaps", icon: Warning, component: GapAnalysis, testid: "cap-tab-gaps" },
  { value: "evidence", label: "Evidence", icon: SealCheck, component: EvidencePanel, testid: "cap-tab-evidence" },
  { value: "executive", label: "Executive", icon: Presentation, component: ExecutiveDashboard, testid: "cap-tab-executive" },
  { value: "taxonomy", label: "Taxonomy", icon: TreeStructure, component: TaxonomyAdmin, testid: "cap-tab-taxonomy", roles: ["ADMIN", "MANAGER"] },
];

export default function Capability() {
  const { user } = useAuth();
  const visible = TABS.filter((t) => !t.roles || t.roles.includes(user?.role));

  return (
    <div className="p-4 md:p-6 lg:p-8 max-w-[1440px] mx-auto" data-testid="capability-page">
      <div className="mb-5 flex items-center gap-3">
        <span className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: CP.navy }}>
          <Graph size={24} color="#fff" weight="duotone" />
        </span>
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em]" style={{ color: CP.sub }}>Organizational Intelligence</div>
          <h1 className="text-2xl sm:text-3xl tracking-tight font-bold">Capability Graph</h1>
        </div>
      </div>

      <div className="rounded-2xl p-4 md:p-5" style={{ background: CP.bg, border: `1px solid ${CP.border}` }}>
        <Tabs defaultValue="explorer" className="w-full">
          <TabsList className="flex-wrap h-auto gap-1 p-1 rounded-xl mb-2" style={{ background: "#fff", border: `1px solid ${CP.border}` }}>
            {visible.map((t) => (
              <TabsTrigger key={t.value} value={t.value} data-testid={t.testid}
                className="rounded-lg text-xs px-3 py-2 data-[state=active]:!bg-[#12275A] data-[state=active]:!text-white"
                style={{ color: CP.sub }}>
                <t.icon size={14} className="mr-1.5" /> {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {visible.map((t) => (
            <TabsContent key={t.value} value={t.value} className="pt-3">
              <t.component />
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
